import React from "react";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils/cn";

interface SectionHeaderProps {
  eyebrow?: string;
  icon?: React.ElementType;
  title: string;
  href?: string;
  viewAllLabel?: string;
  className?: string;
}

export function SectionHeader({
  eyebrow,
  icon: Icon,
  title,
  href,
  viewAllLabel = "View all",
  className,
}: SectionHeaderProps) {
  return (
    <div className={cn("flex items-center justify-between mb-10", className)}>
      <div>
        {eyebrow && (
          <div className="eyebrow flex items-center gap-2">
            {Icon && <Icon className="h-3.5 w-3.5 text-primary" />}
            {eyebrow}
          </div>
        )}
        <h2 className="mt-3 font-display text-2xl font-semibold tracking-tight text-foreground">
          {title}
        </h2>
      </div>
      {href && (
        <Button variant="ghost" size="sm" asChild>
          <Link href={href}>
            {viewAllLabel} <ArrowRight className="ml-1 h-4 w-4" />
          </Link>
        </Button>
      )}
    </div>
  );
}
